module.exports = __webpack_public_path__ + "img/picto-auth.41c8a528.png";